interface CodeBlockReplacement {
  href: string;
  match: string;
  beforeMatch: RegExp | null;
}

const clientIdReplacement: CodeBlockReplacement = {
  href: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/api-keys`,
  match: 'client_123456789',
  beforeMatch: null,
};

const secretKeyReplacement: CodeBlockReplacement = {
  href: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/api-keys`,
  match: 'sk_example_123456789',
  beforeMatch: null,
};

const authkitDomainReplacement: CodeBlockReplacement = {
  href: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}`,
  match: 'authkit_domain',
  beforeMatch: null,
};

const customAuthDomainReplacement: CodeBlockReplacement = {
  href: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}`,
  match: 'api_workos_com',
  beforeMatch: null,
};

export const CODE_BLOCK_REPLACEMENTS = {
  authkitDomain: authkitDomainReplacement,
  customAuthDomain: customAuthDomainReplacement,
  clientId: clientIdReplacement,
  secretKey: secretKeyReplacement,
} as const;
